export const MEMBERSHIP_STATUS = {
  active: { label: "Активен", tone: "success" },
  pending: { label: "Ожидает оплаты", tone: "warn" },
  expired: { label: "Истёк", tone: "muted" },
  frozen: { label: "Заморожен", tone: "warn" },
  cancelled: { label: "Отменён", tone: "muted" },
};

export function membershipStatusMeta(status, notes, membership) {
  const due = Number(membership?.amount_due);
  if (
    (status === "active" || status === "frozen") &&
    Number.isFinite(due) &&
    due > 0
  ) {
    return {
      label: `Долг ${Math.round(due).toLocaleString("ru-RU")} ₽`,
      tone: "warn",
    };
  }
  if (
    status === "cancelled" &&
    notes &&
    (/Зачислен|Продление:\s*\+|Пополнение применено/i.test(notes))
  ) {
    return { label: "Зачислен", tone: "success" };
  }
  return MEMBERSHIP_STATUS[status] || { label: status || "—", tone: "muted" };
}

export function formatMembershipPeriod(membership) {
  if (!membership) return null;
  const parts = [];
  if (membership.starts_at) {
    parts.push(
      new Date(membership.starts_at).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    );
  }
  if (membership.ends_at) {
    parts.push(
      new Date(membership.ends_at).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    );
  }
  if (parts.length === 2) return `${parts[0]} — ${parts[1]}`;
  if (parts.length === 1) return parts[0];
  return null;
}

export function membershipVisitsLine(membership, stats) {
  const mv = stats?.membership_visits;
  const left =
    mv?.is_visit_based && mv.remaining != null
      ? mv.remaining
      : membership?.visits_remaining != null
        ? membership.visits_remaining
        : null;
  if (left == null) return null;

  const total = mv?.is_visit_based ? mv.total : membership?.plan?.visits_count;
  // После суммирования остаток может быть больше исходного пакета — не пишем «11 из 8»
  if (total != null && Number(total) > 0 && Number(left) <= Number(total)) {
    return `${left} из ${total} занятий`;
  }
  return `${left} ${Number(left) === 1 ? "занятие" : "занятий"}`;
}

